import { useUserStore } from "../../../stores/UserStore"
import { useIntl } from "react-intl"
import useAccessToken from "../../../hooks/AccessToken"
import useUser from "../../../hooks/User"
import { useMerchantStore } from "../../../stores/MerchantStore"
import { usePipelineStore } from "../../../stores/PipelineStore"
import { useMeetingStore } from "../../../stores/MeetingsStore"
import { CustomField } from "../../../interfaces/Settings"
import * as ExcelJS from 'exceljs';
import Swal from "sweetalert2";
import { getCustomFieldsValues } from "../../../functions/ExportTemplateExcel/functionHelperExcel";
import { insertUser } from "../../../api/UsersCRUD"

interface useHandleImportUserProps {
    customFields: CustomField
    setListData: (data: any) => void
    dataLeaders: any
    dataCities: any
    dataRoles: any
    dataAttendanceTemplates: any
    dataSuccess: any
    dataError: any
}

const useHandleImportUser = ({
    customFields,
    setListData,
    dataLeaders,
    dataCities,
    dataRoles,
    dataAttendanceTemplates,
    dataSuccess,
    dataError
}: useHandleImportUserProps) => {
    const intl = useIntl()
    const token = useAccessToken()
    const { simplePipelines } = usePipelineStore()
    const { simpleMerchants } = useMerchantStore()
    const { simpleMeetings } = useMeetingStore()
    const { users } = useUserStore()
    const user = useUser()

    const handleChangeUser = (e: any) => {
        setListData([])
        var check_excel = true
        var empty_excel = false
        var success = false
        const file = e
        const wb = new ExcelJS.Workbook()
        const reader = new FileReader()

        var filteredCustomFieldUsers = Object.fromEntries(
            Object.entries(customFields).filter(([key, value]) => {
                return value && typeof value === 'object' && value.type !== 'serial';
            })
        );

        reader.readAsArrayBuffer(file)
        reader.onload = () => {
            const buffer: any = reader.result
            wb.xlsx.load(buffer).then((workbook: any) => {
                const newData: any = []
                var nameWorksheet = workbook.getWorksheet('Sheet1')
                var nameWorksheetInfo = workbook.getWorksheet('Info')
                if (nameWorksheetInfo !== undefined) {
                    nameWorksheetInfo.eachRow(async (rowInfo: any, rowIndexInfo: number) => {
                        if (rowIndexInfo > 3) {
                            if (
                                rowInfo.values[2] === 'Template Insert User' ||
                                rowInfo.values[2] === 'Template Error Insert User'
                            ) {
                                nameWorksheet?.eachRow((row: any, rowIndex: number) => {
                                    if (rowIndex > 2) {
                                        const rowData = row.values
                                        if (Array.isArray(rowData)) {
                                            var leader: any = dataLeaders.find((data: any) => data.name === rowData[6])
                                            var city: any = dataCities.find((data: any) => data.name === rowData[7])
                                            var role: any = dataRoles.find((data: any) => data.name === rowData[8])
                                            var attendanceTemplate: any = dataAttendanceTemplates.find(
                                                (data: any) => data.name === rowData[9]
                                            )

                                            const customFieldsStartIndex = 11
                                            const customFieldsData = Object.fromEntries(Object.keys(filteredCustomFieldUsers).map((key, index) => {
                                                const rowIndex = customFieldsStartIndex + index;
                                                const rowValue = rowData[rowIndex];
                                                const fieldType = filteredCustomFieldUsers[key].type;
                                                let fieldValue;

                                                if (fieldType === 'image' || fieldType === 'file' || fieldType === 'text' || fieldType === 'link') {
                                                    fieldValue = typeof rowValue === 'object' ? rowValue.text ? rowValue.text : rowValue.url : rowValue;
                                                } else {
                                                    fieldValue = rowValue;
                                                }

                                                return [key, fieldValue];
                                            }));

                                            newData.push({
                                                username: typeof rowData[1] === 'object' ? rowData[1].text ? rowData[1].text : rowData[1].url : rowData[1],
                                                name: typeof rowData[2] === 'object' ? rowData[2].text ? rowData[2].text : rowData[2].url : rowData[2],
                                                nik: typeof rowData[3] === 'object' ? rowData[3].text ? rowData[3].text : rowData[3].url : rowData[3],
                                                phone: typeof rowData[4] === 'object' ? rowData[4].text ? rowData[4].text : rowData[4].url : rowData[4],
                                                password: typeof rowData[5] === 'object' ? rowData[5].text ? rowData[5].text : rowData[5].url : rowData[5],
                                                leader_name: leader?.name,
                                                leader_id: leader?.id,
                                                city_name: city?.name,
                                                city_id: city?.id,
                                                role_name: role?.name,
                                                role_id: role?.id,
                                                attendanceTemplate_name: attendanceTemplate?.name,
                                                attendanceTemplate_id: attendanceTemplate?.id,
                                                date_join: typeof rowData[10] === 'object' ? rowData[10].text ? rowData[10].text : rowData[10].url : rowData[10],
                                                ...customFieldsData
                                            })

                                            check_excel = true
                                            success = true
                                            empty_excel = false
                                        }
                                    } else {
                                        empty_excel = true
                                        return false
                                    }
                                })
                            } else if (
                                rowInfo.values[2] === 'Template Update User' ||
                                rowInfo.values[2] === 'Template Error Update User'
                            ) {
                                nameWorksheet?.eachRow((row: any, rowIndex: number) => {
                                    if (rowIndex > 2) {
                                        const rowData = row.values
                                        if (Array.isArray(rowData)) {
                                            var leader: any = dataLeaders.find((data: any) => data.name === rowData[4])
                                            var city: any = dataCities.find((data: any) => data.name === rowData[5])
                                            var role: any = dataRoles.find((data: any) => data.name === rowData[6])
                                            var attendanceTemplate: any = dataAttendanceTemplates.find(
                                                (data: any) => data.name === rowData[7]
                                            )
                                            var id = atob(rowData[1])
                                            const customFieldsStartIndex = 8

                                            const customFieldsData = Object.fromEntries(Object.keys(filteredCustomFieldUsers).map((key, index) => {
                                                const rowIndex = customFieldsStartIndex + index;
                                                const rowValue = rowData[rowIndex];
                                                const fieldType = filteredCustomFieldUsers[key].type;
                                                let fieldValue;

                                                if (fieldType === 'image' || fieldType === 'file' || fieldType === "text" || fieldType === 'link') {
                                                    fieldValue = typeof rowValue === 'object' ? rowValue.text ? rowValue.text : rowValue.url : rowValue;
                                                } else {
                                                    fieldValue = rowValue;
                                                }

                                                return [key, fieldValue];
                                            }));

                                            newData.push({
                                                id: id.slice(0, 3) + id.slice(6),
                                                name: typeof rowData[2] === 'object' ? rowData[2].text ? rowData[2].text : rowData[2].url : rowData[2],
                                                nik: typeof rowData[3] === 'object' ? rowData[3].text ? rowData[3].text : rowData[3].url : rowData[3],
                                                leader_name: leader?.name,
                                                leader_id: leader?.id,
                                                city_name: city?.name,
                                                city_id: city?.id,
                                                role_name: role?.name,
                                                role_id: role?.id,
                                                attendanceTemplate_name: attendanceTemplate?.name,
                                                attendanceTemplate_id: attendanceTemplate?.id,
                                                ...customFieldsData,
                                            })
                                            check_excel = true
                                            success = true
                                            empty_excel = false
                                        }
                                    } else {
                                        empty_excel = true
                                        return false
                                    }
                                })
                            } else {
                                check_excel = false
                                return false
                            }
                        }
                    })
                } else {
                    check_excel = false
                }

                if (empty_excel) {
                    Swal.fire({
                        icon: 'error',
                        title: intl.formatMessage({ id: 'FORM.VALIDATION.FILL_DATA_FIRST' }),
                        confirmButtonText: 'Ok',
                    })
                }

                if (!check_excel) {
                    Swal.fire({
                        icon: 'error',
                        title: intl.formatMessage({ id: 'FORM.VALIDATION.EXCEL_TEMPLATE_NOT_MATCHING' }),
                        confirmButtonText: 'Ok',
                    })
                }

                if (success) setListData(newData)
            })
        }
    }

    const handleInsertUser = async (data: any) => {
        const customFieldsValues = getCustomFieldsValues(data, customFields, simplePipelines, simpleMerchants, simpleMeetings, users, user)
        const response = await insertUser({
            name: data.name,
            username: data.username,
            password: data.password,
            nik: data.nik === '' ? undefined : data.nik,
            phone: data.phone.replace('+', ''),
            leaderId: data.leader_id === '' ? undefined : data.leader_id,
            cityId: data.city_id,
            dateJoined: data.date_join,
            roleId: data.role_id,
            attendanceTemplateId:
                data.attendanceTemplate_id === '' ? undefined : data.attendanceTemplate_id,
            token: token,
            customFields: customFieldsValues,
        })

        if (response.data.success) {
            dataSuccess.push(response.data.data)
        } else {
        }
    }

    return {
        handleChangeUser,
        handleInsertUser
    }
}

export default useHandleImportUser